import { getData } from "@/components/report/service";
import RouteEntity from "@/Entity/RouteEntity";
import Queryable from "@/Entity/Tools/Queryable";
import GenerateCondit from "@/models/GenerateCondit";
import { CALCWEIGHT, TICKET } from "@/models/GenerateCondit/Interrelated";
import { computeWeights } from "@/utils/query";
import moment from "moment";

export default {
    namespace: 'loadnosendmodals',
    state: {
        modalsVisible: false,
        modalsTitle: '',
        modalsNextSite: '',
        rowData: null,   // 弹窗行信息
        productCalcWeightList: [],
        productTicketList: [],
    },

    effects: {
        *getDetailInfo({ payload }, { call, put, select }) {
            yield put({ type: 'updateState', payload })
            const { rowData } = payload
            // if (!rowData.loadNoSendTaskNo) return

            let query = yield select(({ centerWeightView }) => {
                return {
                    centerFilter: centerWeightView.centerFilter,
                    startDate: moment(centerWeightView.dateRange[0])
                        .format(centerWeightView.defualtDateFormat),
                    endDate: moment(centerWeightView.dateRange[1])
                        .format(centerWeightView.defualtDateFormat),
                }
            });
            const gc = new GenerateCondit({
                dataSource: 'actual_load_unload_result',
                dimensions: ['nextSite', 'scanSite', 'productType'], // , 'taskNo'
                aggregators: [CALCWEIGHT, TICKET],
                startDate: moment(query.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
                endDate: query.endDate,
            })
            const entity = new RouteEntity({
                scanType: '分拨装车',
                isDestinationCenter: '否',
                scanSite: query.centerFilter,
                taskNo: rowData.loadNoSendTaskNo,
            })
            const condit = gc.converCondit(entity)
            const dataSource = yield getData(condit)
            // 提取不同产品类型的重量和票数
            const productCalcWeightList = []    // top3重量
            const productTicketList = []    // top3票数
            dataSource.forEach(item => {
                const ticket = Math.abs(item.ticket)
                const calcWeight = computeWeights(item.calcWeight)
                // 重量占比饼图数据
                if (calcWeight > 0.01) {
                    productCalcWeightList.push({ name: item.productType, value: calcWeight })
                }
                // 票数占比饼图数据
                if (ticket > 0) {
                    productTicketList.push({ name: item.productType, value: ticket })
                }
            })

            yield put({
                type: 'updateState',
                payload: {
                    productCalcWeightList,
                    productTicketList,
                }
            })
        },
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
}
